import { Modal } from "bootstrap";
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import uuid from "react-uuid";
import TapSelect from "../../components/ui/TapSelect";
import POHistoryContentModal from "./purchaseOrder/POHistoryContentModal";
import TransactionLedgerContent from "./includes/TransactionLedgerContent";
import Loader from "../../components/ui/Loader/Loader";
import ConsumptionHistoryContent from "./consumption/ConsumptiomHistoryContent";
import DemandHistoryContent from "./itemDemand/DemandHistoryContent";
import PRHistoryContent from "./requisition/PRHistoryContent";

const HistoryDataModal = forwardRef((props, ref) => {
    const modalElem = useRef(null);
    const modal = useRef(null);
    const [modalId] = useState(uuid());
    const [title, setTitle] = useState("");
    const [selectedType, setSelectedType] = useState(null);
    const [itemData, setItemData] = useState(null);
    const [allParams, setAllParams] = useState({});
    const [options, setOptions] = useState([]);

    useImperativeHandle(ref, () => ({
        modalHistoryInit: (data, options = {}) => {
            setItemData(data);
            setAllParams(options);
            const defaultHistoryTypes = [
                { value: 'consumption', label: 'Consumption History' },
                { value: 'po_history', label: 'PO History' },
                { value: 'pr_history', label: 'PR History' }, 
                { value: 'transaction_ledger', label: 'Item Transaction Ledger' },
                { value: 'demand_history', label: 'Demand History' }

            ];
            const finalOptions = props.historyTypes?.length > 0
                ? props.historyTypes
                : (options.historyTypes?.length > 0
                    ? options.historyTypes
                    : defaultHistoryTypes);

            setOptions(finalOptions);
            const defaultAction = options.defaultAction || 'consumption';
           const defaultSelected = finalOptions.find(opt => opt.value === defaultAction) || finalOptions[0];
            setSelectedType(defaultSelected);
            if (defaultSelected) {
                setTitle(defaultSelected.label);
            }
            modalOpen();
        }
    }));
    

    const handleTypeChange = (selectedOption) => {
        setSelectedType(selectedOption);
         if (selectedOption) {
            setTitle(selectedOption.label);
        }
    };

    const modalOpen = () => {
        if (modal.current) {
            modal.current.show();
        }
    };

 
    const handleLogisticClick = (transactionId) => {
        if (props.onLogisticClick) {
            props.onLogisticClick(transactionId);
        }
    };

    useEffect(() => {
        modalElem.current = document.getElementById(modalId);
        if (modalElem.current) {
            modal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });
        }
        return () => {
            if (modal.current) {
                modal.current.dispose();
            }
        }
    }, [modalId]);

    const renderContent = () => {
        if (!selectedType?.value || !itemData) {
            return <div className="text-center p-5"><Loader /></div>;
        }
        console.log(allParams,'poarams')
       
        switch (selectedType.value) {
            case 'consumption':
                return <ConsumptionHistoryContent
                    itemData={itemData}
                    warehouse_id={allParams.warehouse_id}
                    asset_id={allParams.asset_id}
                    workstation_id={allParams.workstation_id}
                    employee_id={allParams.employee_id}
                    sub_assembly_id={allParams.sub_assembly_id}
                />;
            case 'po_history':
                return <POHistoryContentModal
                    itemData={itemData}
                    warehouse_id={allParams.warehouse_id}
                    indent_transaction_id={allParams.indent_transaction_id || ''}
                    req_item_id={allParams.req_item_id || ''}
                    onLogisticClick={handleLogisticClick}
                />;
            case 'pr_history':  
                return <PRHistoryContent
                    itemData={itemData}
                    // warehouse_id={allParams.warehouse_id}
                    indent_transaction_id={allParams.indent_transaction_id || ''}
                />;
            case 'transaction_ledger':
                return <TransactionLedgerContent
                    itemData={itemData}
                    warehouse_id={allParams.warehouse_id}
                    warehouseDetail={allParams.warehouse_detail}
                    showTransactionType={allParams.showTransactionType || false}
                    onViewTransaction={(transaction_type, transaction_id) => {
                        if (props.onViewTransaction) {
                            props.onViewTransaction(transaction_type, transaction_id);
                        }
                    }}
                />;
                case 'demand_history' :
                    return <DemandHistoryContent
                    itemData={itemData}
                    workstation_id={allParams.workstation_id}
                    asset_id={allParams.asset_id}
                    demand_for={allParams.demand_for}
                />;
            default:
                return <div className="text-center p-5">Select an option to view history</div>;
        }
    };

    return (
        <div className="modal fade" id={modalId} tabIndex="-1" ref={modalElem}>
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    {options.length > 0 && (
                        <div className="p-2 bg-white ms-3" style={{position: "relative" , zIndex : 2}}>
                            <div className="row align-items-center">
                                <div className="col-sm-2">
                                    <label className="form-label fw-bold mb-0">Select Type:</label>
                                </div>
                                <div className="col-sm-4">
                                    <TapSelect
                                        options={options}
                                        value={selectedType}
                                        changeEvent={handleTypeChange}
                                        isSearchable={false}
                                        placeholder="Select History Type"
                                        containerHeight="30px"
                                        fontSize="93%"
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="modal-body" >
                        {renderContent()}
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default HistoryDataModal;